import gql from 'graphql-tag';

import {useQuery} from '../state/graphql/reactApollo';
import {type User} from '../types/graphql';

// This query returns the currently-logged-in User.
export const GET_VIEWER_QUERY = gql`
  query Viewer($includeStorage: Boolean = false) {
    viewer {
      id
      analyticsId
      admin
      email
      entity
      defaultFramework
      photoUrl
      flags
      code
      username
      createdAt
      name
      accountType
      userInfo
      hideTeamsFromPublic
      limits
      nvidiaAccountLinkedAt
      signupRequired
      personalEntityDisabled
      isNvidiaAccountLinked
      instanceAdminTeamAccessDisabled
      teams(first: 100) {
        edges {
          node {
            id
            name
            photoUrl
            defaultAccess
            readOnlyAdmin
            privateOnly
            isTeam
            entityType
            organizationId
          }
        }
      }
      organizations {
        id
        name
        orgType
        subscriptions {
          id
          subscriptionType
        }
      }
      defaultEntity {
        id
        name
      }
      userEntity {
        id
        name
        defaultAccess
        codeSavingEnabled
        storageBytes @include(if: $includeStorage)
        settings {
          defaultCloudRegion {
            id
            provider
            region
          }
        }
        isTeam
        defaultAlerts {
          id
          condition {
            __typename
            ... on FinishedRunCondition {
              success
            }
            ... on StoppedRunCondition {
              minimumRunDuration
            }
          }
          subscriptions {
            __typename
            ... on EmailSubscription {
              id
            }
            ... on SlackChannelSubscription {
              id
            }
          }
        }
        integrations {
          edges {
            node {
              id
              __typename
              ... on SlackIntegration {
                teamName
                channelName
              }
            }
          }
        }
        claimedEntities {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_VIEWER_PHOTO_URL_QUERY = gql`
  query ViewerPhotoURL {
    viewer {
      id
      photoUrl
    }
  }
`;

export const VIEWER_FEATURE_FLAGS = gql`
  query viewerFeatureFlags($rampIDType: RampIDType!) {
    viewer {
      id
      featureFlags(rampIDType: $rampIDType) {
        rampKey
        isEnabled
      }
    }
  }
`;

export interface GetViewerQueryResponse {
  viewerLoading: boolean;
  viewer: User;
  refetch: () => void;
}

// Returns the currently-logged-in user.
export const useViewer = (options?: {includeStorage?: boolean}) => {
  const {data, loading, refetch} = useQuery<GetViewerQueryResponse>(
    GET_VIEWER_QUERY,
    {
      variables: {
        includeStorage: options?.includeStorage ?? false,
      },
    }
  );
  return {
    viewer: data?.viewer,
    viewerLoading: loading,
    refetch,
  };
};
